/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsVpcConnectivityConfig } from '../models/AwsVpcConnectivityConfig';

export class AwsRestoreAccountConnectivityConfig {
  /**
  * VPCs to configure.
  */
  'vpcConfigs'?: Array<AwsVpcConnectivityConfig>;
  /**
  * Indicates if the restore account\'s internet connectivity is disabled. Defaults to false.
  */
  'internetConnectivityDisabled'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vpcConfigs",
      "baseName": "vpcConfigs",
      "type": "Array<AwsVpcConnectivityConfig>",
      "format": ""
    },
    {
      "name": "internetConnectivityDisabled",
      "baseName": "internetConnectivityDisabled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsRestoreAccountConnectivityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

